<a role="button" (click)="navigateURL(brand)">
  <div class="brand-card">
    <div class="brand-image">
      <img src="{{ brand.logoUrl.trim() }}" [alt]="brand.name" title="{{brand.name}}"/>
    </div>
  </div>
</a>
